import { lazyLoad } from 'app/utils/loadable';

export const ChangeEmailErrorPage = lazyLoad(
  () => import('./change-email-error-page'),
  (module) => module.ChangeEmailErrorPage
);
